<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">分红设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>分红任务</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create-task @onSuccess="refreshList"></create-task>
        <update-profit @onSuccess="getProfit"></update-profit>
        <div class="infos">
          <div class="info">
            <span>当前分红池金额：</span>
            <span>{{ profit }} USDT</span>
          </div>
        </div>
      </div>
      <el-table :data="taskList">
        <el-table-column label="分红时间">
          <template slot-scope="scope">
            {{ scope.row.dividendTime | moment('YYYY-MM-DD') }}
          </template>
        </el-table-column>
        <el-table-column label="分红类型">
          <template slot-scope="scope">
            {{ types[scope.row.type] }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="分红金额"> </el-table-column>
        <el-table-column prop="coinType" label="分红币种"> </el-table-column>
        <el-table-column prop="deductionAmount" label="扣减分红池金额">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.__status.color">{{
              scope.row.__status.text
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="200" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | moment }}
          </template>
        </el-table-column>
        <el-table-column width="140" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 1"
              size="small"
              circle
              icon="el-icon-tickets"
              @click="handleCheck(scope.row)"
            ></el-button>
            <el-button
              v-if="scope.row.status === 0"
              type="success"
              icon="el-icon-upload"
              circle
              size="small"
              @click="handleExecute(scope.row)"
            ></el-button>
            <!-- <el-button 
              v-if="scope.row.status === 0"
              type="primary" 
              icon="el-icon-edit" 
              circle
              size="small"
              @click="handleUpdate(scope.row)"
            ></el-button> -->
            <el-button
              v-if="scope.row.status === 0"
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              @click="handleRemove(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handlePageChanged"
      >
      </pagination>
    </el-card>
    <Record></Record>
  </div>
</template>
<script>
import './store';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import UpdateProfit from './components/UpdateProfit';
import CreateTask from './components/CreateTask';
import Record from './components/Record';
import Pagination from 'components/pagination';

export default {
  name: 'DividendTask',
  components: {
    UpdateProfit,
    CreateTask,
    Record,
    Pagination
  },
  data() {
    return {
      types: {
        1: '初级股东分红',
        2: '中级股东分红',
        3: '高级股东分红'
      }
    };
  },
  methods: {
    ...mapActions('dividendTask', [
      'list',
      'getProfit',
      'execute',
      'remove',
      'billTask'
    ]),
    ...mapMutations('dividendTask', ['setCheckTask', 'setRecordDialogVisible']),
    handlePageChanged(pagination) {
      this.list({
        ...pagination
      });
    },
    refreshList() {
      this.list({
        ...this.pagination
      });
    },
    handleExecute(task) {
      this.$confirm('确定执行该任务吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.execute(task.id).then(() => {
            this.$message.success('执行成功！');
            this.refreshList();
          });
        })
        .catch(() => {});
    },
    handleRemove(task) {
      this.$confirm('确定删除该任务吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.remove(task.id).then(() => {
            this.$message.success('删除成功！');
            this.refreshList();
          });
        })
        .catch(() => {});
    },
    handleCheck(task) {
      this.setCheckTask(task);
      this.setRecordDialogVisible(true);
    },
    handleBill(task) {
      this.billTask(task.id).then(() => {
        this.$$message.success('操作成功！');
      });
    }
  },
  computed: {
    ...mapState('dividendTask', ['pagination', 'totalCount', 'profit']),
    ...mapGetters('dividendTask', ['taskList'])
  },
  mounted() {
    this.getProfit();
    this.list({
      ...this.pagination
    });
  }
};
</script>
<style lang="less" scoped></style>
